interface Language {
  code: string;
  title: string;
}

export const LanguageAvailable: Language[] = [
  {
    code: "en",
    title: "English",
  },
  {
    code: "de",
    title: "German",
  },
  {
    code: "es",
    title: "Spanish",
  },
  {
    code: "fr",
    title: "French",
  },
  {
    code: "it",
    title: "Italian",
  },
  {
    code: "pl",
    title: "Polish",
  },
  {
    code: "pt",
    title: "Portuguese",
  },
  {
    code: "ru",
    title: "Russian",
  },
  {
    code: "uk",
    title: "Ukrainian",
  },
];
